import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxPlayerControlsSettingsComponent } from './player-controls-settings.component';

export const ngxPlayerControlsSettingsModule = angular.module('ngxPlayerControlsSettingsModule', [])
	.directive('ngxPlayerControlsSettings', downgradeComponent({ component: NgxPlayerControlsSettingsComponent }))
	.name;
